'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconClose = function IconClose(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { id: 'icon_close', fill: color },
      _react2.default.createElement('path', { d: 'M11.0285482,11.9998283 L6.20144544,16.826688 C5.93285152,17.0952858 5.93285152,17.5301257 6.20144544,17.7980365 C6.33539893,17.9319919 6.51125581,17.999313 6.6871127,17.999313 C6.86296959,17.999313 7.03882648,17.9319919 7.17277996,17.7980365 L11.9999141,12.9711453 L16.8277352,17.7987234 C16.9616887,17.9326788 17.1375456,18 17.3134025,18 C17.4892594,18 17.6644293,17.9326788 17.7990698,17.7987234 C18.0669767,17.5301257 18.0669767,17.0952858 17.7990698,16.827375 L12.97128,11.9998283 L17.7990698,7.17228154 C18.0669767,6.90437072 18.0669767,6.46953087 17.7990698,6.20093311 C17.5304758,5.9330223 17.0956422,5.9330223 16.8277352,6.20093311 L11.9999141,11.0285112 L7.17277996,6.20162006 C6.90418605,5.9330223 6.46935242,5.9330223 6.20144544,6.20162006 C5.93285152,6.46953087 5.93285152,6.90437072 6.20144544,7.17296849 L11.0285482,11.9998283 Z' }),
      ' '
    )
  );
};

IconClose.propTypes = {
  color: _propTypes2.default.string
};

IconClose.defaultProps = {
  color: _colors2.default.icons
};

IconClose.displayName = 'IconClose';

exports.default = IconClose;
module.exports = exports.default;